'use client'

import { Package } from 'lucide-react'
import styles from '@/components/login/login-left-background-effects.module.css'

export function LoginFloatingLogo() {
  return (
    <div className={styles.floatingLogoField} aria-hidden>
      <div className={styles.floatingLogoOrbit}>
        <div className={styles.floatingLogoInner}>
          <div className={styles.floatingLogoGlow} />
          <div className={styles.floatingLogoMark}>
            <span className="text-[2rem] font-black tracking-tight leading-none">PRIMODR</span>
            <Package className="w-9 h-9 mx-1 stroke-[2.5]" />
            <span className="text-[2rem] font-black tracking-tight leading-none">P</span>
          </div>
        </div>
      </div>
    </div>
  )
}
